// extracted by mini-css-extract-plugin
var _1 = "DatePicker-modulearrow__Oyyia";
var _2 = "DatePicker-moduleselect__YNWCi DateSelect-moduleDateSelect__WQmvb";
export { _1 as "arrow", _2 as "select" }
